import SSAccountCard from "@core-components/accountCard/SSAccountCard";
import SSHeaderCard from "@core-components/accountCard/components/SSHeaderCard";
import ButtonVariants from "@core-components/button/ButtonVariants";
import ProductDetailLine from "@core-components/product-detail-line/ProductDetailLine";
import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import EPublicRoutes from "@core-types/routes.enum";
import useAppLanguage from "@hooks/language/useAppLanguage";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { useAppRegion } from "@hooks/region/useAppRegion";
import getAvailableAccountIds from "@modules/order/hooks/getAvailableAccountIds.hook";
import { IconBolt, IconDroplet, IconWorld } from "@tabler/icons-react";
import type ISkin from "../models/ISkin.model";

interface ISkinCardProps {
  skin: ISkin;
  championSlug: string;
}

const SkinLinkCard: React.FC<ISkinCardProps> = ({ skin, championSlug }) => {
  const { t } = useAppTranslation("components.skinLinkCard");
  const { isOutOfStock, isBuyable } = getAvailableAccountIds(skin.accounts);
  const { currentRegion } = useAppRegion();
  const { locationUrlBuilder } = useAppLanguage();

  const route = locationUrlBuilder(
    EPublicRoutes.SMURFS_SKIN,
    championSlug,
    skin.slug,
  );

  return (
    <SSAccountCard
      href={route}
      header={
        <SSHeaderCard
          backgroundUrl={skin.thumbnail}
          alt={t("alt")}
          isOutOfStock={isOutOfStock}
          variant="skinLink"
        >
          <SSHeadline
            props={{
              stack: { align: "left" },
            }}
          >
            <SSWhiteText>{skin.name}</SSWhiteText>
          </SSHeadline>
        </SSHeaderCard>
      }
    >
      <ProductDetailLine
        key={2}
        color="#60A9FF"
        description={`${isOutOfStock ? 0 : skin.accounts?.length}`}
        icon={IconDroplet}
        label={t("inStock")}
      />
      <ProductDetailLine
        color="#FF7A00"
        description={currentRegion}
        icon={IconWorld}
        label={t("region")}
      />

      <ProductDetailLine
        color="#00B67A"
        description={t("rankedReady")}
        icon={IconBolt}
        label={t("rank")}
      />
      <ButtonVariants.Gradient
        className="h-full rounded-lg py-3 text-lg"
        disabled={!isBuyable}
        label={isOutOfStock ? t("outOfStock") : t("available")}
        href={route}
      />
    </SSAccountCard>
  );
};

export default SkinLinkCard;
